import React, { Component } from "react";
import {
  Tabs, Button, Input, Select, notification, Spin, Row, Col,
  Card, Progress, Tooltip, Tag, Divider, Modal, InputNumber,
} from "antd";
import {
  HomeOutlined, RiseOutlined, DollarOutlined, ToolOutlined,
  ReloadOutlined, PlusOutlined, InfoCircleOutlined,
  TrophyOutlined, BellOutlined, EditOutlined, CheckOutlined,
  LineChartOutlined, SafetyOutlined, ThunderboltOutlined,
  CloseOutlined, WarningOutlined, MailOutlined,
} from "@ant-design/icons";
import { list, noAuthGetInfo } from "../api/Apis";
import { withAppContext } from "../store/contextStore";
import { withRouter } from "react-router-dom";
import { sendValueTrackerCreatedWebhook, sendValueTrackerInterestWebhook } from "../utils/ghlWebhooks";
const { TabPane } = Tabs;
const { Option }  = Select;
// ── Direct API helper — bypasses Apis.js add() which 502s ───────────────────
const MHB_API_BASE = "https://api.myhomebuddha.com/api";
function getIdToken() {
  try {
    var keys = Object.keys(localStorage).filter(function(k) { return k.includes("idToken"); });
    for (var i = 0; i < keys.length; i++) {
      var t = localStorage.getItem(keys[i]);
      if (t && t.length > 20) return t;
    }
  } catch(e) {}
  return null;
}
async function mhbAdd(table, entityData) {
  var token = getIdToken();
  var resp = await fetch(MHB_API_BASE + "/" + table, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": token || "" },
    body: JSON.stringify({ entityData: entityData }),
  });
  var json = await resp.json();
  if (!resp.ok) throw new Error("mhbAdd " + resp.status + ": " + JSON.stringify(json));
  return { success: true, data: json.data || json, id: (json.data || json).id };
}
async function mhbUpdate(table, id, fields) {
  var token = getIdToken();
  var resp = await fetch(MHB_API_BASE + "/" + table + "/" + id, {
    method: "PUT",
    headers: { "Content-Type": "application/json", "Authorization": token || "" },
    body: JSON.stringify(fields),
  });
  var json = await resp.json();
  if (!resp.ok) throw new Error("mhbUpdate " + resp.status + ": " + JSON.stringify(json));
  return { success: true, data: json.data || json };
}
const NAVY   = "#1A2280";
const GOLD   = "#D4921A";
const GREEN  = "#2D6A4F";
const WHITE  = "#FFFFFF";
const BG     = "#F7F9FC";
const BORDER = "#E2E8F0";
const MUTED  = "#718096";
const RED    = "#E53E3E";
const TEAL   = "#319795";
const AI_SITE = "https://ai.myhomebuddha.com";
const IMPROVEMENTS = [
  { id: "roof_new",       label: "New Roof",                category: "Major Systems",  valueLow: 8000,  valueHigh: 20000, icon: "🏠" },
  { id: "hvac_new",       label: "New HVAC System",         category: "Major Systems",  valueLow: 5000,  valueHigh: 12000, icon: "❄️" },
  { id: "hvac_service",   label: "HVAC Serviced",           category: "Major Systems",  valueLow: 500,   valueHigh: 2000,  icon: "🔧" },
  { id: "hwh_new",        label: "New Water Heater",        category: "Major Systems",  valueLow: 2000,  valueHigh: 5000,  icon: "💧" },
  { id: "windows_new",    label: "New Windows",             category: "Major Systems",  valueLow: 8000,  valueHigh: 18000, icon: "🪟" },
  { id: "electrical_up",  label: "Electrical Panel Upgrade",category: "Major Systems",  valueLow: 3000,  valueHigh: 8000,  icon: "⚡" },
  { id: "plumbing_up",    label: "Plumbing Update",         category: "Major Systems",  valueLow: 2000,  valueHigh: 7000,  icon: "🚿" },
  { id: "insulation",     label: "Insulation / Weatherize", category: "Major Systems",  valueLow: 1500,  valueHigh: 4000,  icon: "🌡️" },
  { id: "kitchen_full",   label: "Full Kitchen Remodel",    category: "Kitchen & Bath", valueLow: 20000, valueHigh: 45000, icon: "🍳" },
  { id: "kitchen_minor",  label: "Kitchen Update (minor)",  category: "Kitchen & Bath", valueLow: 5000,  valueHigh: 15000, icon: "🍳" },
  { id: "bath_full",      label: "Full Bathroom Remodel",   category: "Kitchen & Bath", valueLow: 10000, valueHigh: 25000, icon: "🛁" },
  { id: "bath_minor",     label: "Bathroom Update (minor)", category: "Kitchen & Bath", valueLow: 3000,  valueHigh: 8000,  icon: "🚿" },
  { id: "bath_add",       label: "Added Bathroom",          category: "Kitchen & Bath", valueLow: 15000, valueHigh: 35000, icon: "🛁" },
  { id: "siding_new",     label: "New Siding / Exterior",   category: "Exterior",       valueLow: 8000,  valueHigh: 20000, icon: "🏡" },
  { id: "landscaping",    label: "Landscaping Improvement", category: "Exterior",       valueLow: 2000,  valueHigh: 8000,  icon: "🌱" },
  { id: "driveway",       label: "New Driveway / Walkway",  category: "Exterior",       valueLow: 3000,  valueHigh: 10000, icon: "🛣️" },
  { id: "deck_add",       label: "Deck / Patio Added",      category: "Exterior",       valueLow: 8000,  valueHigh: 20000, icon: "🌳" },
  { id: "garage_door",    label: "New Garage Door",         category: "Exterior",       valueLow: 2000,  valueHigh: 5000,  icon: "🚗" },
  { id: "paint_ext",      label: "Exterior Repainted",      category: "Exterior",       valueLow: 2000,  valueHigh: 6000,  icon: "🎨" },
  { id: "flooring",       label: "New Flooring / Hardwood", category: "Interior",       valueLow: 5000,  valueHigh: 15000, icon: "🪵" },
  { id: "paint_int",      label: "Interior Repainted",      category: "Interior",       valueLow: 1500,  valueHigh: 4000,  icon: "🎨" },
  { id: "basement_finish",label: "Finished Basement",       category: "Interior",       valueLow: 20000, valueHigh: 50000, icon: "🏗️" },
  { id: "attic_finish",   label: "Finished Attic / Bonus",  category: "Interior",       valueLow: 15000, valueHigh: 35000, icon: "🏗️" },
  { id: "closets",        label: "Closet / Storage Systems",category: "Interior",       valueLow: 1000,  valueHigh: 4000,  icon: "📦" },
  { id: "solar",          label: "Solar Panels Installed",  category: "Energy & Smart", valueLow: 10000, valueHigh: 25000, icon: "☀️" },
  { id: "smart_home",     label: "Smart Home Upgrades",     category: "Energy & Smart", valueLow: 1500,  valueHigh: 5000,  icon: "📱" },
  { id: "ev_charger",     label: "EV Charger Installed",    category: "Energy & Smart", valueLow: 2000,  valueHigh: 5000,  icon: "⚡" },
  { id: "generator",      label: "Whole-Home Generator",    category: "Energy & Smart", valueLow: 5000,  valueHigh: 12000, icon: "🔋" },
];
const IMPROVEMENT_CATEGORIES = [...new Set(IMPROVEMENTS.map(i => i.category))];
function fmt$(n) {
  if (!n) return "$0";
  return "$" + Number(n).toLocaleString();
}
function fmtPct(n) {
  if (!n && n !== 0) return "—";
  return (n > 0 ? "+" : "") + n.toFixed(1) + "%";
}
function normalizeAIReport(r) {
  const d   = r.data || r.reportData || r;
  const avm = d.avm || d.valuation || {};
  const sub = d.subject || {};
  return {
    reportId:   r.id || r.reportId || "",
    address:    r.address || d.address || r.addr || "",
    avm:        avm.estimate || avm.value || avm.avm || avm.mid || avm.price || null,
    avmLow:     avm.low  || avm.rangeLow  || null,
    avmHigh:    avm.high || avm.rangeHigh || null,
    confidence: d.confidence ? (d.confidence.score || d.confidence) : null,
    comps:      d.comps || [],
    beds:       sub.bedrooms   || d.beds    || null,
    baths:      sub.bathrooms  || d.baths   || null,
    sqft:       sub.livingArea || d.sqft    || null,
    yearBuilt:  sub.yearBuilt  || d.yearBuilt || null,
    date:       r.updatedAt || r.createdAt || r.savedAt || 0,
    reportType: r.reportType || r.mode || "seller",
  };
}
class ValueTracker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab:          "dashboard",
      loading:            true,
      avmLoading:         false,
      triggerRefreshLoading: false,
      saving:             false,
      showSetup:          false,
      setupStep:          0,
      setupMode:          "new",  // "new" = add property, "edit" = full re-setup of active tracker
      setupForm: {
        address: "", purchasePrice: "", purchaseDate: "",
        mortgageBalance: "", mortgageRate: "", mortgageType: "30yr fixed",
        downPayment: "", propertyTax: "",
      },
      avmResult:          null,
      // Multi-property support
      trackers:           [],     // all valueTracker records for this user
      activeTrackerId:    null,   // id of the currently viewed tracker
      // Monthly value-refresh notifications (written by valueRefreshCronJob Lambda)
      notifications:      [],     // recordType:"notification", type:"value_update" rows
      lastViewedUpdate:   null,   // most recent update banner shown for the active tracker
      valueHistory:       [],
      improvements:       [],
      aiReports:          [],
      aiReportsLoading:   false,
      aiReportsExpanded:  false,
      importingId:        null,
      showImproveModal:   false,
      improveForm: {
        improvementId: "", completedDate: "", cost: "",
        contractor: "", notes: "", valueImpact: "",
      },
      milestones: [],
      // Quick edit (single field updates — e.g. pay down mortgage)
      showQuickEdit:      false,
      quickEditForm: {
        purchasePrice: "", mortgageBalance: "", mortgageRate: "",
        mortgageType: "30yr fixed", propertyTax: "",
      },
      // Agent/Lender: set up a client's Value Tracker + invite
      showClientSetup:    false,
      clientSetupForm: {
        clientName: "", clientEmail: "",
        address: "", purchasePrice: "", purchaseDate: "",
        mortgageBalance: "", mortgageRate: "", mortgageType: "30yr fixed",
        downPayment: "", propertyTax: "",
      },
      sendingInvite:      false,
      // Tracks whether the setup currently open was self-initiated or arrived
      // via an agent/lender's pre-filled invite link — used only to label the
      // GHL "value_tracker_created" webhook event, see saveTracker().
      vtSource:           "self_setup",
      // Anonymous (not-yet-logged-in) capture flow — see openAddProperty(),
      // handleSetupNext(), and captureAnonAddress(). anonMode means the
      // person who opened the setup modal isn't logged in, so we only let
      // them enter + confirm an address (no financial details) before
      // gating them to log in / create an account. showAnonGate swaps the
      // modal body to that login-or-create-account prompt once they've
      // confirmed their address.
      anonMode:           false,
      showAnonGate:       false,
    };
  }
  componentDidMount() {
    this.loadTrackers();
    this.checkPrefillFromInvite();
  }
  // ── Check for an agent-sent prefill invite (?vt=base64json in URL) ────────────
  checkPrefillFromInvite = () => {
    try {
      var params = new URLSearchParams(window.location.search);
      var vt = params.get("vt");
      if (!vt) return;
      var decoded = JSON.parse(atob(decodeURIComponent(vt)));
      // Only apply if user has no trackers yet — don't clobber existing setup
      var setupForm = {
        address:         decoded.address || "",
        purchasePrice:   decoded.purchasePrice || "",
        purchaseDate:    decoded.purchaseDate || "",
        mortgageBalance: decoded.mortgageBalance || "",
        mortgageRate:    decoded.mortgageRate || "",
        mortgageType:    decoded.mortgageType || "30yr fixed",
        downPayment:     decoded.downPayment || "",
        propertyTax:     decoded.propertyTax || "",
      };
      this.setState({ pendingInviteSetup: setupForm });
    } catch(e) { /* not a valid invite param — ignore */ }
  };
  // ── Anonymous address capture — see captureAnonAddress() ───────────────────────
  getPendingValueTrackerCapture = () => {
    try { return JSON.parse(localStorage.getItem("mhb_pending_valuetracker") || "null"); }
    catch(e) { return null; }
  };
  loadTrackers = async () => {
    const { userDetails } = this.props.context.state;
    const userId = userDetails && userDetails.id;
    if (!userId) { this.setState({ loading: false }); return; }
    this.setState({ loading: true });
    try {
      const resp    = await list("mybuddha", { userId });
      const records = resp.success ? (resp.data || []) : [];
      const trackers = records.filter(r => r.recordType === "valueTracker" && !r.deleted);
      // Parse compsJSON back to array for each tracker
      trackers.forEach(function(t) {
        if (t.compsJSON && typeof t.compsJSON === "string") {
          try { t.comps = JSON.parse(t.compsJSON); } catch(e) { t.comps = []; }
        } else if (!t.comps) { t.comps = []; }
      });
      // Sort newest first
      trackers.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
      const allHistory     = records.filter(r => r.recordType === "valueSnapshot");
      const allImprovements = records.filter(r => r.recordType === "homeImprovement");
      const notifications  = records.filter(r => r.recordType === "notification" && r.type === "value_update" && !r.read);
      var activeId = (this.state.activeTrackerId && trackers.find(t => t.id === this.state.activeTrackerId))
        ? this.state.activeTrackerId
        : (trackers[0] ? trackers[0].id : null);
      var activeTracker = trackers.find(t => t.id === activeId) || null;
      var history = activeTracker
        ? allHistory.filter(r => r.trackerId === activeId || (!r.trackerId && r.address === activeTracker.address))
            .sort((a, b) => new Date(a.snapshotDate) - new Date(b.snapshotDate))
        : [];
      var improvements = activeTracker
        ? allImprovements.filter(r => r.trackerId === activeId || (!r.trackerId && r.address === activeTracker.address))
            .sort((a, b) => new Date(b.completedDate) - new Date(a.completedDate))
        : [];
      this.setState({
        trackers, activeTrackerId: activeId,
        valueHistory: history, improvements, notifications,
        loading: false, showSetup: trackers.length === 0,
        setupMode: "new",
      });
      if (activeTracker) this.computeMilestones(activeTracker, history);
      if (activeId) this.markNotificationsRead(activeId);
      // Apply a pending agent invite prefill (from the AI-site share link) if present
      if (trackers.length === 0 && this.state.pendingInviteSetup) {
        const pre = this.state.pendingInviteSetup;
        this.setState({ setupForm: pre, setupStep: 1, setupMode: "new", showSetup: true, vtSource: "agent_invite" });
        if (pre.address) {
          this.refreshAVM(pre.address);
          notification.info({ message: "Welcome!", description: "Your agent set up most of your Value Tracker details — just confirm and launch.", duration: 6 });
        }
      }
      // Otherwise, check for an address this same person looked up anonymously
      // before logging in/creating an account (see captureAnonAddress()) —
      // resume setup right where they left off instead of making them
      // re-enter the address.
      else if (trackers.length === 0 && this.getPendingValueTrackerCapture()) {
        const pending = this.getPendingValueTrackerCapture();
        this.setState({
          setupForm: {
            address: pending.address, purchasePrice: "", purchaseDate: "",
            mortgageBalance: "", mortgageRate: "", mortgageType: "30yr fixed",
            downPayment: "", propertyTax: "",
          },
          setupStep: 1, setupMode: "new", showSetup: true, anonMode: false, showAnonGate: false,
        });
        this.refreshAVM(pending.address);
        try { localStorage.removeItem("mhb_pending_valuetracker"); } catch(e) {}
        notification.info({ message: "Welcome back!", description: "Let's finish setting up your Value Tracker for " + pending.address.split(",")[0] + "." });
      }
      // Otherwise, check for a home_profile record (created at closing by an agent/lender
      // via "Create a Home Profile") that has valueTrackerPrefill data and no tracker yet
      else if (trackers.length === 0) {
        let homeProfile = records.find(r =>
          (r.type === "home_profile" || r.action === "home_profile") &&
          r.valueTrackerPrefill && r.address
        );
        // Fallback: the record may live under the agent's account if the client
        // hadn't signed up yet at closing — check via referring agent + coUsers email match
        if (!homeProfile) {
          try {
            const refId = userDetails.referedById || userDetails.referredBy || userDetails.invitedBy || userDetails.referredByAgent;
            const myEmail = (userDetails.email || "").toLowerCase();
            if (refId && myEmail) {
              const agentResp = await list("mybuddha", { userId: refId });
              if (agentResp && agentResp.success && Array.isArray(agentResp.data)) {
                homeProfile = agentResp.data.find(r =>
                  (r.type === "home_profile" || r.action === "home_profile") &&
                  r.valueTrackerPrefill && r.address &&
                  Array.isArray(r.coUsers) && r.coUsers.some(cu => (cu.email || "").toLowerCase() === myEmail)
                );
              }
            }
          } catch(e) { console.warn("ValueTracker cross-agent prefill check:", e.message); }
        }
        if (homeProfile) {
          const pre = homeProfile.valueTrackerPrefill;
          const setupForm = {
            address:         homeProfile.address || "",
            purchasePrice:   pre.purchasePrice   || "",
            purchaseDate:    pre.purchaseDate    || "",
            mortgageBalance: pre.mortgageBalance || "",
            mortgageRate:    pre.mortgageRate    || "",
            mortgageType:    pre.mortgageType    || "30yr fixed",
            downPayment:     pre.downPayment     || "",
            propertyTax:     pre.propertyTax     || "",
          };
          this.setState({ setupForm, setupStep: 1, setupMode: "new", showSetup: true, vtSource: "agent_invite" });
          this.refreshAVM(setupForm.address);
          notification.info({ message: "Welcome!", description: "Your agent already entered most of your home's details — just confirm and launch your Value Tracker.", duration: 6 });
        }
      }
    } catch(e) {
      console.error("ValueTracker load:", e);
      this.setState({ loading: false });
    }
  };
  // ── Active tracker helper ─────────────────────────────────────────────────────
  getActiveTracker = () => {
    const { trackers, activeTrackerId } = this.state;
    return trackers.find(t => t.id === activeTrackerId) || null;
  };
  // ── Monthly value-refresh notifications (written by valueRefreshCronJob) ──────
  getUnreadNotificationsForTracker = (trackerId) => {
    const { notifications } = this.state;
    return notifications.filter(n => n.trackerId === trackerId);
  };
  getUnreadCountForTracker = (trackerId) => {
    return this.getUnreadNotificationsForTracker(trackerId).length;
  };
  // Surfaces the most recent unread update for a tracker into a dismissible
  // dashboard banner, then clears the underlying notification record(s) as
  // read. The banner itself stays visible (showing what changed) until the
  // user explicitly dismisses it — clearing `read` server-side immediately
  // would otherwise make the badge AND the explanation vanish in the same
  // tick, defeating the point of telling them what changed.
  markNotificationsRead = async (trackerId) => {
    const unread = this.getUnreadNotificationsForTracker(trackerId);
    if (unread.length === 0) return;
    const mostRecent = unread.reduce((a, b) =>
      new Date(a.createdAt || 0) > new Date(b.createdAt || 0) ? a : b
    );
    this.setState(p => ({
      notifications: p.notifications.filter(n => n.trackerId !== trackerId),
      lastViewedUpdate: { trackerId, ...mostRecent },
    }));
    try {
      await Promise.all(unread.map(n => mhbUpdate("mybuddha", n.id, { read: true, readAt: new Date().toISOString() })));
    } catch(e) {
      console.warn("[ValueTracker] markNotificationsRead failed:", e.message);
      // Non-fatal — worst case the badge reappears next loadTrackers() call
    }
  };
  dismissUpdateBanner = () => this.setState({ lastViewedUpdate: null });
  switchProperty = async (id) => {
    const { trackers } = this.state;
    var tracker = trackers.find(t => t.id === id);
    if (!tracker) return;
    this.setState({ activeTrackerId: id, activeTab: "dashboard", loading: true, lastViewedUpdate: null });
    this.markNotificationsRead(id);
    try {
      const { userDetails } = this.props.context.state;
      const resp    = await list("mybuddha", { userId: userDetails.id });
      const records = resp.success ? (resp.data || []) : [];
      var history = records.filter(r => r.recordType === "valueSnapshot")
        .filter(r => r.trackerId === id || (!r.trackerId && r.address === tracker.address))
        .sort((a, b) => new Date(a.snapshotDate) - new Date(b.snapshotDate));
      var improvements = records.filter(r => r.recordType === "homeImprovement")
        .filter(r => r.trackerId === id || (!r.trackerId && r.address === tracker.address))
        .sort((a, b) => new Date(b.completedDate) - new Date(a.completedDate));
      this.setState({ valueHistory: history, improvements, loading: false });
      this.computeMilestones(tracker, history);
    } catch(e) {
      this.setState({ loading: false });
    }
  };
  // ── AI report import ──────────────────────────────────────────────────────────
  loadAIReports = async () => {
    const { userDetails } = this.props.context.state;
    const userId = userDetails && userDetails.id;
    if (!userId) return;
    this.setState({ aiReportsLoading: true });
    try {
      const resp    = await list("mybuddha", { userId });
      const records = resp.success ? (resp.data || []) : [];
      const aiReports = records
        .filter(r => {
          const mode = r.reportType || r.mode || "";
          if (!["seller", "value", "homeowner"].includes(mode)) return false;
          const d = r.data || r.reportData || r;
          const avm = d.avm || d.valuation || {};
          const val = avm.estimate || avm.value || avm.avm || avm.mid || avm.price;
          return val && r.address;
        })
        .map(normalizeAIReport)
        .filter(r => r.address && r.avm)
        .sort((a, b) => (b.date || 0) - (a.date || 0))
        .slice(0, 15);
      this.setState({ aiReports, aiReportsLoading: false });
    } catch(e) {
      console.error("loadAIReports:", e);
      this.setState({ aiReportsLoading: false });
    }
  };
  getAISellerUrl = (mode) => {
    const { userDetails } = this.props.context.state;
    const uid   = (userDetails && (userDetails.id || userDetails.userId)) || "";
    const first = (userDetails && userDetails.firstName) || "";
    const last  = (userDetails && userDetails.lastName)  || "";
    const slug  = (first + last).replace(/[^a-zA-Z0-9]/g, "") || "seller";
    const path  = mode ? ("/" + mode) : "/seller";
    const params = uid ? ("?uid=" + encodeURIComponent(uid)) : "";
    return AI_SITE + "/" + slug + path + params;
  };
  handleImportAIReport = (report) => {
    this.setState({ importingId: report.reportId });
    const avmResult = report.avm ? {
      avm: {
        price: report.avm,
        low:   report.avmLow   || Math.round(report.avm * 0.93),
        high:  report.avmHigh  || Math.round(report.avm * 1.07),
      },
      comps: report.comps || [],
    } : null;
    setTimeout(() => {
      this.setState({
        setupForm:         { ...this.state.setupForm, address: report.address || "" },
        avmResult,
        showSetup:         true,
        setupStep:         1,
        aiReportsExpanded: false,
        importingId:       null,
      });
      notification.success({
        message: "Report imported!",
        description: report.address.split(",")[0] + " loaded — enter your purchase details to finish setup.",
        placement: "topRight", duration: 4,
      });
    }, 300);
  };
  refreshAVM = async (address) => {
    this.setState({ avmLoading: true });
    try {
      const resp = await fetch(AI_SITE + "/.netlify/functions/property-data", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address }),
      });
      const data = await resp.json();
      if (data.avm && data.avm.price) {
        this.setState({ avmResult: data, avmLoading: false });
        return data;
      }
      notification.warning({ message: "Could not pull live AVM", description: "Address not found. You can enter a manual estimate." });
      this.setState({ avmLoading: false });
      return null;
    } catch(e) {
      notification.error({ message: "AVM lookup failed", description: e.message });
      this.setState({ avmLoading: false });
      return null;
    }
  };
  handleSetupNext = async () => {
    const { setupStep, setupForm, anonMode } = this.state;
    if (setupStep === 0) {
      if (!setupForm.address) { notification.warning({ message: "Please enter your property address" }); return; }
      await this.refreshAVM(setupForm.address);
      if (anonMode) {
        // Anonymous visitor — capture the lead right here and gate them to
        // log in / create an account instead of asking for purchase price
        // and mortgage details, which should live behind a real account.
        this.captureAnonAddress();
      } else {
        this.setState({ setupStep: 1 });
      }
    } else if (setupStep < 3) {
      this.setState(p => ({ setupStep: p.setupStep + 1 }));
    } else {
      await this.saveTracker();
    }
  };
  requireLogin = () => {
    const userLogin = localStorage.getItem("userLogin");
    if (userLogin) return true;
    this.props.history.push({ pathname: "/login", state: { from: this.props.location.pathname } });
    return false;
  };
  // ── Open setup modal to add a brand-new property ──────────────────────────────
  // No longer gated behind requireLogin() — an anonymous visitor can open this
  // and enter/confirm an address (captured as a lead below); they're only
  // required to log in or create an account once they try to go past that,
  // since purchase price / mortgage details should live behind a real account.
  openAddProperty = () => {
    const userLogin = localStorage.getItem("userLogin");
    this.setState({
      showSetup: true, setupStep: 0, setupMode: "new", avmResult: null, vtSource: "self_setup",
      anonMode: !userLogin, showAnonGate: false,
      setupForm: {
        address: "", purchasePrice: "", purchaseDate: "",
        mortgageBalance: "", mortgageRate: "", mortgageType: "30yr fixed",
        downPayment: "", propertyTax: "",
      },
    });
  };
  // ── Anonymous address capture — fires the lead webhook, stashes the address
  // so it's waiting for them right after they log in / create an account
  // (see loadTrackers()), then swaps the modal to the login-or-create gate.
  captureAnonAddress = () => {
    const { setupForm, avmResult } = this.state;
    try {
      localStorage.setItem("mhb_pending_valuetracker", JSON.stringify({
        address: setupForm.address, capturedAt: new Date().toISOString(),
      }));
    } catch(e) {}
    sendValueTrackerInterestWebhook({
      address: setupForm.address,
      avm:     (avmResult && avmResult.avm && avmResult.avm.price) || null,
      avmLow:  (avmResult && avmResult.avm && avmResult.avm.low)   || null,
      avmHigh: (avmResult && avmResult.avm && avmResult.avm.high)  || null,
    });
    this.setState({ showAnonGate: true });
  };
  goToLogin = () => {
    this.setState({ showSetup: false, showAnonGate: false });
    this.props.history.push({ pathname: "/login", state: { from: this.props.location.pathname } });
  };
  goToRegister = () => {
    this.setState({ showSetup: false, showAnonGate: false });
    this.props.history.push({ pathname: "/register", state: { from: this.props.location.pathname } });
  };
  // ── Open setup modal pre-filled to edit the active property ───────────────────
  openEditProperty = () => {
    const t = this.getActiveTracker();
    if (!t) return;
    this.setState({
      showSetup: true, setupStep: 1, setupMode: "edit",
      avmResult: (t.currentAVM ? { avm: { price: t.currentAVM, low: t.avmLow, high: t.avmHigh }, comps: t.comps || [] } : null),
      setupForm: {
        address:         t.address || "",
        purchasePrice:   t.purchasePrice   ? String(t.purchasePrice)   : "",
        purchaseDate:    t.purchaseDate    || "",
        mortgageBalance: t.mortgageBalance ? String(t.mortgageBalance) : "",
        mortgageRate:    t.mortgageRate    || "",
        mortgageType:    t.mortgageType    || "30yr fixed",
        downPayment:     t.downPayment     ? String(t.downPayment)     : "",
        propertyTax:     t.propertyTax     ? String(t.propertyTax)     : "",
      },
    });
  };
  notifyGHLValueTrackerCreated = (entityData) => {
    const { userDetails } = this.props.context.state;
    sendValueTrackerCreatedWebhook({
      firstName:       userDetails.firstName || "",
      lastName:        userDetails.lastName  || "",
      email:           userDetails.email || null,
      phone:           userDetails.phone || userDetails.phno || null,
      address:         entityData.address || "",
      purchasePrice:   entityData.purchasePrice   || null,
      mortgageBalance: entityData.mortgageBalance || null,
      currentAVM:      entityData.currentAVM      || null,
      currentEquity:   entityData.currentEquity   || null,
      source:          this.state.vtSource || "self_setup",
    });
  };
  saveTracker = async () => {
    const { setupForm, avmResult, setupMode } = this.state;
    const activeTracker = this.getActiveTracker();
    const { userDetails } = this.props.context.state;
    if (!setupForm.purchasePrice) { notification.warning({ message: "Please enter your purchase price" }); return; }
    this.setState({ saving: true });
    const now     = new Date().toISOString();
    const avmPrice = (avmResult && avmResult.avm && avmResult.avm.price) || 0;
    const avmLow   = (avmResult && avmResult.avm && avmResult.avm.low)   || 0;
    const avmHigh  = (avmResult && avmResult.avm && avmResult.avm.high)  || 0;
    const mortBal  = setupForm.mortgageBalance ? Number(String(setupForm.mortgageBalance).replace(/[^0-9.]/g,"")) : 0;
    const equity   = avmPrice ? avmPrice - mortBal : 0;
    const pp       = Number(String(setupForm.purchasePrice).replace(/[^0-9.]/g,"")) || 0;
    // editing the currently active tracker vs adding a brand new property
    const isEdit = (setupMode === "edit" && activeTracker && activeTracker.id);
    const entityData = {
      userId:          userDetails.id || "",
      recordType:      "valueTracker",
      address:         setupForm.address || "",
      purchasePrice:   pp,
      mortgageBalance: mortBal,
      mortgageType:    setupForm.mortgageType || "30yr fixed",
      currentAVM:      avmPrice,
      avmLow:          avmLow,
      avmHigh:          avmHigh,
      currentEquity:   equity,
      lastAVMRefresh:  now,
      createdAt:       isEdit ? (activeTracker.createdAt || now) : now,
      updatedAt:       now,
      improvementValue: isEdit ? (activeTracker.improvementValue || 0) : 0,
    };
    if (setupForm.purchaseDate) entityData.purchaseDate = setupForm.purchaseDate;
    if (setupForm.mortgageRate) entityData.mortgageRate = setupForm.mortgageRate;
    if (setupForm.downPayment)  entityData.downPayment  = Number(String(setupForm.downPayment).replace(/[^0-9.]/g,""));
    if (setupForm.propertyTax)  entityData.propertyTax  = Number(String(setupForm.propertyTax).replace(/[^0-9.]/g,""));
    try {
      let result;
      let trackerId;
      if (isEdit) {
        result = await mhbUpdate("mybuddha", activeTracker.id, entityData);
        trackerId = activeTracker.id;
      } else {
        result = await mhbAdd("mybuddha", entityData);
        trackerId = result && result.data && result.data.id;
      }
      if (result && result.success) {
        await mhbAdd("mybuddha", {
          userId:          userDetails.id || "",
          recordType:      "valueSnapshot",
          trackerId:       trackerId || "",
          address:         setupForm.address || "",
          snapshotDate:    now,
          avm:             avmPrice,
          mortgageBalance: mortBal,
          equity:          equity,
          improvementValue: 0,
          source:          isEdit ? "edit" : "setup",
        });
        if (!isEdit) this.notifyGHLValueTrackerCreated(entityData);
        notification.success({
          message: isEdit ? "Property updated!" : "Property added! 🎉",
          description: isEdit ? "Your changes have been saved." : "Your new Value Tracker is ready.",
        });
        this.setState({ showSetup: false, saving: false, activeTrackerId: trackerId || this.state.activeTrackerId });
        await this.loadTrackers();
      } else {
        throw new Error((result && result.errors) ? result.errors : "Save failed - please try again");
      }
    } catch(e) {
      notification.error({ message: "Save failed", description: String(e.message || e) });
      this.setState({ saving: false });
    }
  };
  // ── Quick edit — update a single field (e.g. pay down mortgage) without re-running AVM ──
  openQuickEdit = () => {
    const t = this.getActiveTracker();
    if (!t) return;
    this.setState({
      showQuickEdit: true,
      quickEditForm: {
        purchasePrice:   t.purchasePrice   ? String(t.purchasePrice)   : "",
        mortgageBalance: t.mortgageBalance ? String(t.mortgageBalance) : "",
        mortgageRate:    t.mortgageRate    || "",
        mortgageType:    t.mortgageType    || "30yr fixed",
        propertyTax:     t.propertyTax     ? String(t.propertyTax)     : "",
      },
    });
  };
  saveQuickEdit = async () => {
    const t = this.getActiveTracker();
    if (!t) return;
    const { quickEditForm } = this.state;
    const { userDetails } = this.props.context.state;
    this.setState({ saving: true });
    const now = new Date().toISOString();
    const pp      = quickEditForm.purchasePrice   ? Number(String(quickEditForm.purchasePrice).replace(/[^0-9.]/g,""))   : (t.purchasePrice || 0);
    const mortBal = quickEditForm.mortgageBalance ? Number(String(quickEditForm.mortgageBalance).replace(/[^0-9.]/g,"")) : 0;
    const avm     = t.currentAVM || 0;
    const equity  = avm ? avm - mortBal : (t.currentEquity || 0);
    const fields = {
      purchasePrice:   pp,
      mortgageBalance: mortBal,
      mortgageType:    quickEditForm.mortgageType || "30yr fixed",
      currentEquity:   equity,
      updatedAt:       now,
    };
    if (quickEditForm.mortgageRate) fields.mortgageRate = quickEditForm.mortgageRate;
    if (quickEditForm.propertyTax)  fields.propertyTax  = Number(String(quickEditForm.propertyTax).replace(/[^0-9.]/g,""));
    try {
      const result = await mhbUpdate("mybuddha", t.id, fields);
      if (result && result.success) {
        // Log a snapshot so the value-history chart reflects the change
        await mhbAdd("mybuddha", {
          userId:          userDetails.id || "",
          recordType:      "valueSnapshot",
          trackerId:       t.id,
          address:         t.address || "",
          snapshotDate:    now,
          avm:             avm,
          mortgageBalance: mortBal,
          equity:          equity,
          improvementValue: t.improvementValue || 0,
          source:          "quick_edit",
        });
        notification.success({ message: "Updated!", description: "Your mortgage and purchase details have been saved." });
        this.setState({ showQuickEdit: false, saving: false });
        await this.loadTrackers();
      } else {
        throw new Error((result && result.errors) ? result.errors : "Save failed");
      }
    } catch(e) {
      notification.error({ message: "Save failed", description: String(e.message || e) });
      this.setState({ saving: false });
    }
  };
  doRefreshAVM = async () => {
    const t = this.getActiveTracker();
    if (!t || !t.address) return;
    const data = await this.refreshAVM(t.address);
    if (!data || !data.avm || !data.avm.price) return;
    const { userDetails } = this.props.context.state;
    const now    = new Date().toISOString();
    const equity = data.avm.price - (t.mortgageBalance || 0);
    await mhbUpdate("mybuddha", t.id, {
      currentAVM:     data.avm.price || 0,
      avmLow:         data.avm.low   || 0,
      avmHigh:        data.avm.high  || 0,
      currentEquity:  equity || 0,
      lastAVMRefresh: now,
      updatedAt:      now,
    });
    await mhbAdd("mybuddha", {
      userId:          userDetails.id,
      recordType:      "valueSnapshot",
      trackerId:       t.id,
      address:         t.address || "",
      snapshotDate:    now,
      avm:             data.avm.price || 0,
      mortgageBalance: t.mortgageBalance || 0,
      equity:          equity || 0,
      improvementValue: t.improvementValue || 0,
      source:          "manual_refresh",
    });
    notification.success({ message: "Value updated!" });
    await this.loadTrackers();
  };
  // Agent/lender-only: pushes a fresh AVM + comp pull + teaser email to the
  // homeowner right now via the backend /triggerValueRefresh route, instead
  // of waiting for the monthly cron. Distinct from doRefreshAVM above —
  // that one is a quick client-side AVM peek with no email; this one mirrors
  // the full monthly pipeline (snapshot, notification badge, email) for a
  // single tracker on demand.
  triggerValueRefreshNow = async () => {
    const t = this.getActiveTracker();
    if (!t) return;
    this.setState({ triggerRefreshLoading: true });
    try {
      const result = await mhbAdd("triggerValueRefresh", { trackerId: t.id });
      const d = result && result.data;
      const change = d && d.deltas ? d.deltas.avmChange : null;
      notification.success({
        message: "Value refreshed and sent",
        description: change !== null
          ? "Updated value " + fmt$(d.avm) + (change >= 0 ? " (+" : " (") + fmt$(change) + " since last update). Email sent to the homeowner."
          : "Updated value sent to the homeowner.",
      });
      await this.loadTrackers();
    } catch (e) {
      notification.error({ message: "Couldn't refresh value", description: e.message || "Please try again." });
    } finally {
      this.setState({ triggerRefreshLoading: false });
    }
  };
  saveImprovement = async () => {
    const { improveForm } = this.state;
    const t = this.getActiveTracker();
    const { userDetails } = this.props.context.state;
    if (!improveForm.improvementId) { notification.warning({ message: "Select an improvement type" }); return; }
    this.setState({ saving: true });
    const template    = IMPROVEMENTS.find(i => i.id === improveForm.improvementId);
    const valueMid    = template ? Math.round((template.valueLow + template.valueHigh) / 2) : 0;
    const valueImpact = improveForm.valueImpact ? Number(String(improveForm.valueImpact).replace(/[^0-9.]/g,"")) : valueMid;
    const now = new Date().toISOString();
    try {
      await mhbAdd("mybuddha", {
        userId: userDetails.id, recordType: "homeImprovement",
        trackerId: t && t.id || "",
        address: t && t.address || "",
        improvementId: improveForm.improvementId, label: template && template.label || "",
        category: template && template.category || "",
        completedDate: improveForm.completedDate || now.split("T")[0],
        cost: improveForm.cost ? Number(String(improveForm.cost).replace(/[^0-9.]/g,"")) : 0,
        contractor: improveForm.contractor || "", notes: improveForm.notes || "",
        valueImpact, valueLow: template && template.valueLow || 0, valueHigh: template && template.valueHigh || 0,
        createdAt: now,
      });
      const newTotal = (t && t.improvementValue || 0) + valueImpact;
      await mhbUpdate("mybuddha", t.id, { improvementValue: newTotal, updatedAt: now });
      notification.success({ message: "Improvement logged! +" + fmt$(valueImpact) + " estimated value added" });
      this.setState({
        showImproveModal: false,
        improveForm: { improvementId: "", completedDate: "", cost: "", contractor: "", notes: "", valueImpact: "" },
        saving: false,
      });
      await this.loadTrackers();
    } catch(e) {
      notification.error({ message: "Save failed", description: e.message });
      this.setState({ saving: false });
    }
  };
  computeMilestones = (tracker, history) => {
    if (!tracker) return;
    const milestones = [];
    const equity    = tracker.currentEquity || 0;
    const avm       = tracker.currentAVM    || 0;
    const purchase  = tracker.purchasePrice || 0;
    const equityPct = avm > 0 ? equity / avm : 0;
    if (equityPct >= 0.20) {
      milestones.push({ id: "pmi", icon: "🎉", color: GREEN, reached: true,
        title: "PMI Removal Eligible",
        desc: "You have reached 20% equity. Contact your lender to request PMI removal — this could save you $100-$300/month.", cta: "Learn how to remove PMI" });
    } else {
      const needed = Math.max(0, Math.ceil(avm * 0.20 - equity));
      milestones.push({ id: "pmi", icon: "🏁", color: GOLD, reached: false,
        title: "PMI Removal", desc: fmt$(needed) + " more in equity until you reach 20% and can remove PMI.",
        progress: Math.min(99, Math.round(equityPct / 0.20 * 100)) });
    }
    if (equityPct >= 0.25) {
      milestones.push({ id: "heloc", icon: "💳", color: TEAL, reached: true,
        title: "HELOC Opportunity",
        desc: "With " + fmtPct(equityPct * 100) + " equity you may qualify for a HELOC of up to " + fmt$(Math.round(equity * 0.85)) + ". Great for renovations.", cta: "Explore HELOC options" });
    }
    const appreciation = avm - purchase;
    const appPct = purchase > 0 ? appreciation / purchase * 100 : 0;
    if (appreciation >= 100000) {
      milestones.push({ id: "100k", icon: "🏆", color: GOLD, reached: true,
        title: fmt$(Math.floor(appreciation / 10000) * 10000) + " in Appreciation",
        desc: "Your home has appreciated " + fmtPct(appPct) + " since purchase. " + (appPct > 15 ? "Above average — great market." : "Steady growth.") });
    }
    if (equityPct >= 0.15 && equity >= 50000) {
      milestones.push({ id: "moveup", icon: "⬆️", color: NAVY, reached: true,
        title: "Move-Up Power",
        desc: "Using your equity as a down payment, you could potentially afford a home up to " + fmt$(Math.round(equity * 0.7) + avm) + ".", cta: "Talk to an agent" });
    }
    this.setState({ milestones });
  };
  // ── Import panel ──────────────────────────────────────────────────────────────
  renderImportPanel() {
    const { aiReports, aiReportsLoading, aiReportsExpanded, importingId } = this.state;
    const aiSellerUrl = this.getAISellerUrl("seller");
    const fv = v => v ? "$" + Number(v).toLocaleString() : "—";
    const fd = ts => { if (!ts) return ""; const d = new Date(typeof ts === "number" ? ts : Date.parse(ts)); return isNaN(d) ? "" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }); };
    return (
      <div style={{ background: "#EEF0FC", border: "1.5px solid #C5CAF0", borderRadius: "14px", marginBottom: "20px", overflow: "hidden" }}>
        <div style={{ background: "linear-gradient(90deg," + NAVY + ",#2A3390)", padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "22px" }}>📊</span>
            <div>
              <div style={{ color: GOLD, fontWeight: 800, fontSize: "14px" }}>Import or Run a Valuation</div>
              <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "11px" }}>Use a saved AI report or run a fresh one</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <button onClick={() => { const exp = !aiReportsExpanded; this.setState({ aiReportsExpanded: exp }); if (exp && aiReports.length === 0) this.loadAIReports(); }}
              style={{ padding: "7px 14px", background: aiReportsExpanded ? "rgba(255,255,255,0.25)" : "rgba(255,255,255,0.12)", border: "1.5px solid rgba(255,255,255,0.35)", borderRadius: "50px", color: WHITE, fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>
              {aiReportsExpanded ? "▲ Hide Reports" : "📥 Import Saved Report"}
            </button>
            <a href={aiSellerUrl} target="_blank" rel="noopener noreferrer"
              style={{ padding: "7px 16px", background: GOLD, borderRadius: "50px", color: "#2A1600", fontSize: "12px", fontWeight: 800, textDecoration: "none", whiteSpace: "nowrap" }}>
              🏠 Run New Valuation
            </a>
          </div>
        </div>
        {aiReportsExpanded && (
          <div style={{ padding: "16px 18px" }}>
            {aiReportsLoading && <div style={{ textAlign: "center", padding: "24px" }}><Spin size="small" /><div style={{ marginTop: "8px", fontSize: "12px", color: MUTED }}>Loading your saved reports...</div></div>}
            {!aiReportsLoading && aiReports.length === 0 && (
              <div style={{ textAlign: "center", padding: "24px 16px", background: WHITE, borderRadius: "10px", border: "1px solid " + BORDER }}>
                <div style={{ fontSize: "32px", marginBottom: "8px" }}>📋</div>
                <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY, marginBottom: "6px" }}>No saved valuations yet</div>
                <div style={{ fontSize: "12px", color: MUTED, marginBottom: "14px" }}>Run a seller or home value analysis on the AI site, then come back to import it.</div>
                <a href={aiSellerUrl} target="_blank" rel="noopener noreferrer"
                  style={{ display: "inline-block", padding: "9px 20px", background: NAVY, color: WHITE, borderRadius: "50px", fontSize: "12px", fontWeight: 700, textDecoration: "none" }}>
                  Get My Home Value
                </a>
              </div>
            )}
            {!aiReportsLoading && aiReports.length > 0 && (
              <div>
                <div style={{ fontSize: "11px", color: MUTED, marginBottom: "12px", fontWeight: 600 }}>{aiReports.length} saved report{aiReports.length !== 1 ? "s" : ""} — click Import to pre-fill setup</div>
                {aiReports.map(r => (
                  <div key={r.reportId} style={{ background: WHITE, border: "1.5px solid " + BORDER, borderRadius: "10px", padding: "12px 14px", marginBottom: "8px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", flexWrap: "wrap" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: "2px" }}>{r.address.split(",")[0]}</div>
                      <div style={{ fontSize: "11px", color: MUTED, marginBottom: "5px" }}>{r.address.split(",").slice(1).join(",").trim()}</div>
                      <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                        <span style={{ fontSize: "15px", fontWeight: 800, color: GREEN }}>{fv(r.avm)}</span>
                        {r.avmLow && r.avmHigh && <span style={{ fontSize: "11px", color: MUTED }}>{fv(r.avmLow)} – {fv(r.avmHigh)}</span>}
                        {r.confidence && <span style={{ fontSize: "10px", fontWeight: 700, color: r.confidence >= 70 ? GREEN : r.confidence >= 50 ? "#D97706" : MUTED, background: r.confidence >= 70 ? "#F0FDF4" : r.confidence >= 50 ? "#FFFBF0" : "#F7F9FC", padding: "2px 7px", borderRadius: "20px" }}>{r.confidence}% confidence</span>}
                        {r.date && <span style={{ fontSize: "10px", color: "#A0AEC0" }}>{fd(r.date)}</span>}
                      </div>
                      {(r.beds || r.sqft) && <div style={{ fontSize: "11px", color: MUTED, marginTop: "3px" }}>{[r.beds && (r.beds + " bd"), r.baths && (r.baths + " ba"), r.sqft && (Number(r.sqft).toLocaleString() + " sqft"), r.yearBuilt && ("built " + r.yearBuilt)].filter(Boolean).join(" · ")}</div>}
                    </div>
                    <button onClick={() => this.handleImportAIReport(r)} disabled={importingId === r.reportId}
                      style={{ padding: "8px 18px", background: importingId === r.reportId ? BORDER : NAVY, color: importingId === r.reportId ? MUTED : WHITE, border: "none", borderRadius: "50px", fontSize: "12px", fontWeight: 700, cursor: importingId === r.reportId ? "default" : "pointer", whiteSpace: "nowrap" }}>
                      {importingId === r.reportId ? "Importing..." : "Import →"}
                    </button>
                  </div>
                ))}
                <div style={{ marginTop: "10px", padding: "10px 14px", background: "#FFFBF0", border: "1px solid #F0C080", borderRadius: "8px", fontSize: "11px", color: "#92400E" }}>
                  Importing pre-fills your address and AVM — you still enter purchase price and mortgage to complete setup.
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
  renderDashboard() {
    const { valueHistory, improvements, milestones, avmLoading, lastViewedUpdate, triggerRefreshLoading } = this.state;
    const trackerRecord = this.getActiveTracker();
    if (!trackerRecord) return null;
    const avm       = trackerRecord.currentAVM      || 0;
    const equity    = trackerRecord.currentEquity   || 0;
    const purchase  = trackerRecord.purchasePrice   || 0;
    const mortgage  = trackerRecord.mortgageBalance || 0;
    const impValue  = trackerRecord.improvementValue || 0;
    const apprecVal = avm - purchase;
    const apprecPct = purchase > 0 ? apprecVal / purchase * 100 : 0;
    const equityPct = avm > 0 ? equity / avm * 100 : 0;
    const lastRefresh = trackerRecord.lastAVMRefresh ? new Date(trackerRecord.lastAVMRefresh).toLocaleDateString() : "—";
    const showUpdateBanner = lastViewedUpdate && lastViewedUpdate.trackerId === trackerRecord.id;
    return (
      <div style={{ padding: "16px" }}>
        {showUpdateBanner && (
          <div style={{ background: "linear-gradient(135deg," + NAVY + ",#2A3390)", borderRadius: "12px", padding: "14px 18px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "14px", flexWrap: "wrap" }}>
            <span style={{ fontSize: "24px", flexShrink: 0 }}>📬</span>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <div style={{ color: GOLD, fontWeight: 800, fontSize: "13px", marginBottom: "4px" }}>Your monthly value update is here</div>
              <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "12px", lineHeight: 1.6 }}>
                {lastViewedUpdate.avmChange !== undefined && (
                  lastViewedUpdate.avmChange > 0
                    ? "Your estimated value is up " + fmt$(lastViewedUpdate.avmChange) + " since your last update. "
                    : lastViewedUpdate.avmChange < 0
                      ? "Your estimated value shifted by " + fmt$(Math.abs(lastViewedUpdate.avmChange)) + " since your last update. "
                      : "Your estimated value held steady this month. "
                )}
                {lastViewedUpdate.newCompsCount > 0 && (lastViewedUpdate.newCompsCount + " new comparable sale" + (lastViewedUpdate.newCompsCount !== 1 ? "s" : "") + " nearby. ")}
              </div>
            </div>
            <button onClick={this.dismissUpdateBanner}
              style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "50%", width: "26px", height: "26px", cursor: "pointer", color: WHITE, fontSize: "12px", flexShrink: 0 }}>✕</button>
          </div>
        )}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px", flexWrap: "wrap", gap: "8px" }}>
          <div>
            <div style={{ fontSize: "16px", fontWeight: 800, color: NAVY }}>{trackerRecord.address}</div>
            <div style={{ fontSize: "12px", color: MUTED }}>AVM last updated: {lastRefresh}</div>
          </div>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            <Button icon={<ReloadOutlined />} loading={avmLoading} onClick={this.doRefreshAVM} style={{ borderRadius: "50px", borderColor: NAVY, color: NAVY, fontWeight: 700 }}>Refresh Value</Button>
            {this.isAgentOrLender() && (
              <Button icon={<MailOutlined />} loading={triggerRefreshLoading} onClick={this.triggerValueRefreshNow}
                title="Pull a fresh value + comps now and email the homeowner, instead of waiting for the monthly update"
                style={{ borderRadius: "50px", borderColor: GOLD, color: "#92400E", fontWeight: 700, background: "#FFF8E6" }}>
                Send Update to Client
              </Button>
            )}
            <Button icon={<EditOutlined />} onClick={this.openQuickEdit} style={{ borderRadius: "50px" }}>Quick Edit</Button>
            <Button onClick={this.openEditProperty} style={{ borderRadius: "50px" }}>Full Edit</Button>
            <a href={this.getAISellerUrl("seller")} target="_blank" rel="noopener noreferrer"
              style={{ display: "inline-flex", alignItems: "center", padding: "0 14px", height: "32px", background: GOLD, borderRadius: "50px", color: "#2A1600", fontSize: "12px", fontWeight: 700, textDecoration: "none", whiteSpace: "nowrap" }}>
              🏠 Full AI Report
            </a>
          </div>
        </div>
        <Row gutter={[12, 12]} style={{ marginBottom: "16px" }}>
          {[
            { label: "Est. Market Value",  value: fmt$(avm),      sub: avm ? ("Range: " + fmt$(trackerRecord.avmLow) + " – " + fmt$(trackerRecord.avmHigh)) : "Run refresh to update", color: NAVY,  icon: <HomeOutlined /> },
            { label: "Your Equity",        value: fmt$(equity),   sub: equityPct.toFixed(1) + "% of value", color: GREEN, icon: <DollarOutlined /> },
            { label: "Appreciation",       value: fmt$(apprecVal > 0 ? apprecVal : 0), sub: fmtPct(apprecPct) + " since purchase", color: apprecPct >= 0 ? TEAL : RED, icon: <RiseOutlined /> },
            { label: "Improvement Value",  value: fmt$(impValue), sub: improvements.length + " improvement" + (improvements.length !== 1 ? "s" : "") + " logged", color: GOLD, icon: <ToolOutlined /> },
          ].map(({ label, value, sub, color, icon }) => (
            <Col key={label} xs={12} md={6}>
              <Card style={{ borderRadius: "14px", border: "1px solid " + BORDER, textAlign: "center", height: "100%" }} bodyStyle={{ padding: "14px 10px" }}>
                <div style={{ color, fontSize: "22px", marginBottom: "4px" }}>{icon}</div>
                <div style={{ fontSize: "22px", fontWeight: 800, color }}>{value}</div>
                <div style={{ fontSize: "11px", fontWeight: 700, color: NAVY, marginTop: "2px" }}>{label}</div>
                <div style={{ fontSize: "11px", color: MUTED, marginTop: "2px" }}>{sub}</div>
              </Card>
            </Col>
          ))}
        </Row>
        <Card style={{ borderRadius: "14px", border: "1px solid " + BORDER, marginBottom: "16px" }} bodyStyle={{ padding: "16px 20px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
            <span style={{ fontSize: "13px", fontWeight: 700, color: NAVY }}>Equity Position</span>
            <span style={{ fontSize: "13px", color: MUTED }}>{fmt$(equity)} of {fmt$(avm)}</span>
          </div>
          <Progress percent={Math.min(100, Math.round(equityPct))} strokeColor={equityPct >= 20 ? GREEN : GOLD} trailColor={BORDER} strokeWidth={12}
            format={pct => <span style={{ fontSize: "12px", fontWeight: 700 }}>{pct}%</span>} />
          <Row style={{ marginTop: "10px" }}>
            <Col span={8}><div style={{ fontSize: "11px", color: MUTED }}>Mortgage: <strong style={{ color: RED }}>{fmt$(mortgage)}</strong></div></Col>
            <Col span={8} style={{ textAlign: "center" }}><div style={{ fontSize: "11px", color: MUTED }}>Equity: <strong style={{ color: GREEN }}>{fmt$(equity)}</strong></div></Col>
            <Col span={8} style={{ textAlign: "right" }}><div style={{ fontSize: "11px", color: MUTED }}>Improvements: <strong style={{ color: GOLD }}>{fmt$(impValue)}</strong></div></Col>
          </Row>
        </Card>
        {valueHistory.length > 1 && (
          <Card style={{ borderRadius: "14px", border: "1px solid " + BORDER, marginBottom: "16px" }} bodyStyle={{ padding: "16px 20px" }}>
            <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY, marginBottom: "12px" }}><LineChartOutlined style={{ marginRight: "6px" }} />Value History</div>
            <div style={{ display: "flex", alignItems: "flex-end", gap: "6px", height: "60px" }}>
              {valueHistory.slice(-12).map((snap, i, arr) => {
                const maxVal = Math.max(...arr.map(s => s.avm || 0));
                const minVal = Math.min(...arr.map(s => s.avm || 0));
                const range  = maxVal - minVal || 1;
                const h      = Math.max(8, Math.round(((snap.avm || 0) - minVal) / range * 52) + 8);
                const isLast = i === arr.length - 1;
                return (
                  <Tooltip key={i} title={new Date(snap.snapshotDate).toLocaleDateString() + ": " + fmt$(snap.avm)}>
                    <div style={{ flex: 1, height: h + "px", background: isLast ? NAVY : NAVY + "40", borderRadius: "4px 4px 0 0", cursor: "pointer" }} />
                  </Tooltip>
                );
              })}
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "4px" }}>
              <span style={{ fontSize: "10px", color: MUTED }}>{new Date(valueHistory[0] && valueHistory[0].snapshotDate).toLocaleDateString("en-US", { month: "short", year: "2-digit" })}</span>
              <span style={{ fontSize: "10px", color: MUTED }}>Today</span>
            </div>
          </Card>
        )}
        {milestones.length > 0 && (
          <Card style={{ borderRadius: "14px", border: "1px solid " + BORDER, marginBottom: "16px" }} bodyStyle={{ padding: "16px 20px" }}>
            <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY, marginBottom: "12px" }}><TrophyOutlined style={{ marginRight: "6px" }} />Equity Milestones</div>
            {milestones.map(m => (
              <div key={m.id} style={{ display: "flex", gap: "12px", alignItems: "flex-start", padding: "10px 0", borderBottom: "1px solid " + BORDER }}>
                <span style={{ fontSize: "20px", flexShrink: 0 }}>{m.icon}</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "13px", fontWeight: 700, color: m.color }}>{m.title}</div>
                  <div style={{ fontSize: "12px", color: MUTED, lineHeight: 1.5, marginTop: "2px" }}>{m.desc}</div>
                  {!m.reached && m.progress !== undefined && <Progress percent={m.progress} strokeColor={m.color} trailColor={BORDER} size="small" style={{ marginTop: "6px", maxWidth: "240px" }} />}
                  {m.cta && <Button size="small" style={{ marginTop: "8px", borderRadius: "50px", borderColor: m.color, color: m.color, fontSize: "11px" }}>{m.cta} →</Button>}
                </div>
                {m.reached && <CheckOutlined style={{ color: m.color, fontSize: "16px" }} />}
              </div>
            ))}
          </Card>
        )}
        {avm > 0 && purchase > 0 && trackerRecord.purchaseDate && (
          <Card style={{ borderRadius: "14px", background: "linear-gradient(135deg," + NAVY + ",#2A3390)", border: "none", marginBottom: "16px" }} bodyStyle={{ padding: "16px 20px" }}>
            <div style={{ fontSize: "13px", fontWeight: 800, color: GOLD, marginBottom: "10px" }}>📈 Your Home vs The Market</div>
            <Row gutter={[16, 8]}>
              <Col span={12}>
                <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.6)", marginBottom: "2px" }}>Your Home Appreciation</div>
                <div style={{ fontSize: "20px", fontWeight: 800, color: apprecPct >= 0 ? "#68D391" : "#FC8181" }}>{fmtPct(apprecPct)}</div>
                <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>{fmt$(apprecVal > 0 ? apprecVal : 0)} gain</div>
              </Col>
              <Col span={12}>
                <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.6)", marginBottom: "2px" }}>S&P 500 (avg 10%/yr)</div>
                <div style={{ fontSize: "20px", fontWeight: 800, color: "#A0AEC0" }}>
                  {(() => { const years = (new Date() - new Date(trackerRecord.purchaseDate)) / (365.25 * 86400000); return fmtPct((Math.pow(1.10, years) - 1) * 100); })()}
                </div>
                <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>on same down payment</div>
              </Col>
            </Row>
            <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.35)", marginTop: "10px" }}>For illustration only. Past performance does not guarantee future results.</div>
          </Card>
        )}
        {improvements.length > 0 && (
          <Card style={{ borderRadius: "14px", border: "1px solid " + BORDER }} bodyStyle={{ padding: "16px 20px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
              <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY }}><ToolOutlined style={{ marginRight: "6px" }} />Recent Improvements</div>
              <Button size="small" style={{ borderRadius: "50px", borderColor: NAVY, color: NAVY, fontSize: "11px" }} onClick={() => this.setState({ activeTab: "improvements" })}>See all</Button>
            </div>
            {improvements.slice(0, 3).map(imp => (
              <div key={imp.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid " + BORDER }}>
                <div>
                  <div style={{ fontSize: "13px", fontWeight: 600, color: NAVY }}>{imp.label}</div>
                  <div style={{ fontSize: "11px", color: MUTED }}>{imp.completedDate}{imp.contractor ? " · " + imp.contractor : ""}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: "13px", fontWeight: 700, color: GREEN }}>+{fmt$(imp.valueImpact)}</div>
                  {imp.cost > 0 && <div style={{ fontSize: "11px", color: MUTED }}>Cost: {fmt$(imp.cost)}</div>}
                </div>
              </div>
            ))}
          </Card>
        )}
      </div>
    );
  }
  renderImprovements() {
    const { improvements } = this.state;
    const totalValue = improvements.reduce((s, i) => s + (i.valueImpact || 0), 0);
    const totalCost  = improvements.reduce((s, i) => s + (i.cost       || 0), 0);
    const roi        = totalCost > 0 ? ((totalValue - totalCost) / totalCost * 100) : null;
    return (
      <div style={{ padding: "16px" }}>
        <Row align="middle" justify="space-between" style={{ marginBottom: "16px" }}>
          <div>
            <div style={{ fontSize: "15px", fontWeight: 800, color: NAVY }}>Home Improvements</div>
            <div style={{ fontSize: "12px", color: MUTED }}>Log completed work to track added value</div>
          </div>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => this.setState({ showImproveModal: true })} style={{ borderRadius: "50px", background: NAVY, borderColor: NAVY, fontWeight: 700 }}>Log Improvement</Button>
        </Row>
        {improvements.length > 0 && (
          <Row gutter={[12, 12]} style={{ marginBottom: "16px" }}>
            {[
              { label: "Total Value Added", value: fmt$(totalValue), color: GREEN },
              { label: "Total Cost Spent",  value: fmt$(totalCost),  color: NAVY  },
              { label: "Value ROI",         value: roi !== null ? fmtPct(roi) : "—", color: roi > 0 ? GREEN : RED },
            ].map(({ label, value, color }) => (
              <Col key={label} span={8}>
                <Card style={{ borderRadius: "12px", border: "1px solid " + BORDER, textAlign: "center" }} bodyStyle={{ padding: "12px 8px" }}>
                  <div style={{ fontSize: "18px", fontWeight: 800, color }}>{value}</div>
                  <div style={{ fontSize: "11px", color: MUTED }}>{label}</div>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        {improvements.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px", color: MUTED }}>
            <ToolOutlined style={{ fontSize: "32px", marginBottom: "12px", display: "block" }} />
            <div style={{ fontWeight: 700, marginBottom: "4px" }}>No improvements logged yet</div>
            <div style={{ fontSize: "13px" }}>Every improvement you make adds to your home value tracker.</div>
          </div>
        ) : improvements.map(imp => (
          <Card key={imp.id} style={{ borderRadius: "12px", border: "1px solid " + BORDER, marginBottom: "10px" }} bodyStyle={{ padding: "14px 18px" }}>
            <Row align="middle">
              <Col flex="1">
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                  <span style={{ fontSize: "18px" }}>{IMPROVEMENTS.find(i => i.id === imp.improvementId) && IMPROVEMENTS.find(i => i.id === imp.improvementId).icon || "🔧"}</span>
                  <span style={{ fontSize: "14px", fontWeight: 700, color: NAVY }}>{imp.label}</span>
                  <Tag style={{ borderRadius: "20px", fontSize: "10px" }}>{imp.category}</Tag>
                </div>
                <div style={{ fontSize: "12px", color: MUTED }}>Completed: {imp.completedDate}{imp.contractor && " · " + imp.contractor}{imp.notes && " · \"" + imp.notes + "\""}</div>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <div style={{ fontSize: "15px", fontWeight: 800, color: GREEN }}>+{fmt$(imp.valueImpact)}</div>
                {imp.cost > 0 && <div style={{ fontSize: "12px", color: MUTED }}>Cost: {fmt$(imp.cost)}</div>}
                {imp.cost > 0 && <div style={{ fontSize: "11px", color: imp.valueImpact > imp.cost ? GREEN : MUTED }}>ROI: {fmtPct((imp.valueImpact - imp.cost) / imp.cost * 100)}</div>}
              </Col>
            </Row>
          </Card>
        ))}
      </div>
    );
  }
  renderComps() {
    const trackerRecord = this.getActiveTracker();
    const comps = (trackerRecord && trackerRecord.comps) || [];
    return (
      <div style={{ padding: "16px" }}>
        <div style={{ fontSize: "15px", fontWeight: 800, color: NAVY, marginBottom: "4px" }}>Comparable Sales</div>
        <div style={{ fontSize: "12px", color: MUTED, marginBottom: "16px" }}>Recent sales used to calculate your estimated value</div>
        {comps.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px", color: MUTED }}>
            <HomeOutlined style={{ fontSize: "32px", marginBottom: "12px", display: "block" }} />
            <div>No comp data yet — refresh your value to pull current comparables.</div>
          </div>
        ) : comps.slice(0, 10).map((c, i) => (
          <Card key={i} style={{ borderRadius: "12px", border: "1px solid " + BORDER, marginBottom: "10px" }} bodyStyle={{ padding: "12px 16px" }}>
            <Row align="middle">
              <Col flex="1">
                <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY }}>{c.address || c.formattedAddress || "—"}</div>
                <div style={{ fontSize: "12px", color: MUTED }}>
                  {c.bedrooms && (c.bedrooms + "bd ")}
                  {c.bathrooms && (c.bathrooms + "ba")}
                  {c.squareFootage && (" · " + Number(c.squareFootage).toLocaleString() + " sqft")}
                  {c.distance && (" · " + c.distance.toFixed(2) + " mi away")}
                </div>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <div style={{ fontSize: "15px", fontWeight: 800, color: NAVY }}>{fmt$(c.price || c.salePrice)}</div>
                <div style={{ fontSize: "11px", color: MUTED }}>{(c.lastSaleDate || c.saleDate) ? new Date(c.lastSaleDate || c.saleDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : ""}</div>
              </Col>
            </Row>
          </Card>
        ))}
      </div>
    );
  }
  renderSetupModal() {
    const { showSetup, setupStep, setupForm, avmResult, avmLoading, saving, setupMode, showAnonGate } = this.state;
    if (!showSetup) return null;
    const isEdit = setupMode === "edit";
    const stepTitles = ["What is your property address?", "What did you pay for your home?", "What is your current mortgage?", isEdit ? "Confirm & Save Changes" : "Confirm & Launch Tracker"];
    const stepSubs   = ["We'll pull live market data and comparable sales.", "Your purchase price is the baseline for tracking appreciation.", "Your mortgage balance determines your equity. You can skip this and update later.", isEdit ? "Review your updated details." : "Review your setup and launch your Value Tracker."];
    return (
      <div style={{ position: "fixed", inset: 0, background: "rgba(10,15,40,0.82)", backdropFilter: "blur(4px)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
        <div style={{ background: "#fff", borderRadius: "20px", width: "100%", maxWidth: "560px", overflow: "hidden", boxShadow: "0 32px 80px rgba(26,34,128,0.25)" }}>
          <div style={{ background: "linear-gradient(135deg," + NAVY + ",#2A3390)", padding: "20px 28px", borderBottom: "3px solid " + GOLD }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: GOLD, fontWeight: 800, fontSize: "16px" }}>{showAnonGate ? "Save Your Home" : (isEdit ? "Edit Property" : "Add Property")}</div>
                <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "12px", marginTop: "2px" }}>{showAnonGate ? "One more step" : "Step " + (setupStep + 1) + " of 4"}</div>
              </div>
              <button onClick={() => this.setState({ showSetup: false, showAnonGate: false })} style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "50%", width: "30px", height: "30px", cursor: "pointer", color: "#fff", fontSize: "14px" }}><CloseOutlined /></button>
            </div>
            {!showAnonGate && (
              <div style={{ display: "flex", gap: "6px", marginTop: "14px" }}>
                {[0,1,2,3].map(i => <div key={i} style={{ height: "4px", flex: 1, borderRadius: "4px", background: i <= setupStep ? GOLD : "rgba(255,255,255,0.2)", transition: "all .3s" }} />)}
              </div>
            )}
          </div>
          <div style={{ padding: "28px" }}>
            <div style={{ fontSize: "18px", fontWeight: 800, color: NAVY, marginBottom: "4px" }}>{showAnonGate ? "Almost there!" : stepTitles[setupStep]}</div>
            <div style={{ fontSize: "13px", color: MUTED, marginBottom: "20px" }}>{showAnonGate ? "We found your home — log in or create a free account to save it and launch your Value Tracker." : stepSubs[setupStep]}</div>
            {showAnonGate && (
              <div>
                {avmResult && avmResult.avm && avmResult.avm.price && (
                  <div style={{ background: GREEN + "12", border: "1.5px solid " + GREEN, borderRadius: "12px", padding: "14px 18px", marginBottom: "16px" }}>
                    <div style={{ fontSize: "12px", color: GREEN, fontWeight: 700, marginBottom: "4px" }}>{setupForm.address}</div>
                    <div style={{ fontSize: "20px", fontWeight: 800, color: GREEN }}>{fmt$(avmResult.avm.price)}</div>
                    <div style={{ fontSize: "12px", color: MUTED }}>Range: {fmt$(avmResult.avm.low)} – {fmt$(avmResult.avm.high)}</div>
                  </div>
                )}
                {!(avmResult && avmResult.avm && avmResult.avm.price) && (
                  <div style={{ background: BG, borderRadius: "12px", padding: "14px 18px", marginBottom: "16px", border: "1px solid " + BORDER }}>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: NAVY }}>{setupForm.address}</div>
                    <div style={{ fontSize: "12px", color: MUTED, marginTop: "2px" }}>We've saved this address — you can enter a manual value estimate after you log in.</div>
                  </div>
                )}
                <div style={{ fontSize: "12px", color: MUTED, marginBottom: "16px" }}>Your address is saved — you won't need to re-enter it.</div>
                <div style={{ display: "flex", gap: "10px", marginBottom: "12px" }}>
                  <Button onClick={this.goToLogin} style={{ borderRadius: "50px", flex: 1, borderColor: NAVY, color: NAVY, fontWeight: 700 }}>Log In</Button>
                  <Button type="primary" onClick={this.goToRegister} style={{ borderRadius: "50px", background: NAVY, borderColor: NAVY, fontWeight: 700, flex: 1 }}>Create Free Account →</Button>
                </div>
                <button onClick={() => this.setState({ showAnonGate: false })}
                  style={{ background: "none", border: "none", color: MUTED, fontSize: "12px", cursor: "pointer", textDecoration: "underline", padding: 0 }}>
                  ← Not the right address? Edit it
                </button>
              </div>
            )}
            {!showAnonGate && setupStep === 0 && (
              <div>
                <div style={{ background: "#EEF0FC", border: "1.5px solid #C5CAF0", borderRadius: "10px", padding: "12px 14px", marginBottom: "16px" }}>
                  <div style={{ fontSize: "12px", fontWeight: 700, color: NAVY, marginBottom: "8px" }}>Have a saved AI valuation? Import it instead:</div>
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    <button onClick={() => { this.setState({ showSetup: false }); setTimeout(() => { this.setState({ aiReportsExpanded: true }); if (this.state.aiReports.length === 0) this.loadAIReports(); }, 100); }}
                      style={{ padding: "7px 14px", background: NAVY, color: WHITE, border: "none", borderRadius: "50px", fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>
                      📥 Import Saved Report
                    </button>
                    <a href={this.getAISellerUrl("seller")} target="_blank" rel="noopener noreferrer"
                      style={{ padding: "7px 14px", background: GOLD, borderRadius: "50px", color: "#2A1600", fontSize: "12px", fontWeight: 700, textDecoration: "none" }}>
                      🏠 Run New Valuation
                    </a>
                  </div>
                  <div style={{ fontSize: "11px", color: MUTED, marginTop: "8px" }}>Or enter your address manually below to look up live data now.</div>
                </div>
                <Input size="large" value={setupForm.address}
                  onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, address: e.target.value } }))}
                  placeholder="123 Main St, Westborough, MA 01581"
                  prefix={<HomeOutlined />} style={{ borderRadius: "10px" }} onPressEnter={this.handleSetupNext} />
              </div>
            )}
            {setupStep === 1 && (
              <div>
                {avmResult && avmResult.avm && avmResult.avm.price && (
                  <div style={{ background: GREEN + "12", border: "1.5px solid " + GREEN, borderRadius: "12px", padding: "14px 18px", marginBottom: "16px" }}>
                    <div style={{ fontSize: "12px", color: GREEN, fontWeight: 700, marginBottom: "4px" }}>Live AVM pulled for your address</div>
                    <div style={{ fontSize: "20px", fontWeight: 800, color: GREEN }}>{fmt$(avmResult.avm.price)}</div>
                    <div style={{ fontSize: "12px", color: MUTED }}>Range: {fmt$(avmResult.avm.low)} – {fmt$(avmResult.avm.high)} · {(avmResult.comps && avmResult.comps.length) || 0} comps found</div>
                  </div>
                )}
                <Row gutter={[12, 12]}>
                  <Col span={12}>
                    <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Purchase Price *</label>
                    <Input prefix="$" placeholder="e.g. 450000" value={setupForm.purchasePrice} onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, purchasePrice: e.target.value } }))} style={{ borderRadius: "10px" }} />
                  </Col>
                  <Col span={12}>
                    <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Purchase Date</label>
                    <Input type="date" value={setupForm.purchaseDate} onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, purchaseDate: e.target.value } }))} style={{ borderRadius: "10px" }} />
                  </Col>
                  <Col span={12}>
                    <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Down Payment Paid</label>
                    <Input prefix="$" placeholder="e.g. 90000" value={setupForm.downPayment} onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, downPayment: e.target.value } }))} style={{ borderRadius: "10px" }} />
                  </Col>
                </Row>
              </div>
            )}
            {setupStep === 2 && (
              <Row gutter={[12, 12]}>
                <Col span={12}>
                  <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Current Balance</label>
                  <Input prefix="$" placeholder="e.g. 360000" value={setupForm.mortgageBalance} onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, mortgageBalance: e.target.value } }))} style={{ borderRadius: "10px" }} />
                </Col>
                <Col span={12}>
                  <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Interest Rate</label>
                  <Input suffix="%" placeholder="e.g. 6.75" value={setupForm.mortgageRate} onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, mortgageRate: e.target.value } }))} style={{ borderRadius: "10px" }} />
                </Col>
                <Col span={12}>
                  <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Loan Type</label>
                  <Select value={setupForm.mortgageType} onChange={v => this.setState(p => ({ setupForm: { ...p.setupForm, mortgageType: v } }))} style={{ width: "100%" }} getPopupContainer={t => t.parentNode}>
                    {["30yr fixed","20yr fixed","15yr fixed","10yr fixed","5/1 ARM","7/1 ARM","No mortgage / Paid off"].map(t => <Option key={t} value={t}>{t}</Option>)}
                  </Select>
                </Col>
                <Col span={12}>
                  <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Annual Property Tax</label>
                  <Input prefix="$" placeholder="e.g. 6200" value={setupForm.propertyTax} onChange={e => this.setState(p => ({ setupForm: { ...p.setupForm, propertyTax: e.target.value } }))} style={{ borderRadius: "10px" }} />
                </Col>
              </Row>
            )}
            {setupStep === 3 && (
              <div>
                {[
                  { label: "Address",          value: setupForm.address },
                  { label: "Purchase Price",   value: fmt$(setupForm.purchasePrice) },
                  { label: "Purchase Date",    value: setupForm.purchaseDate || "—" },
                  { label: "Current AVM",      value: avmResult && avmResult.avm && avmResult.avm.price ? fmt$(avmResult.avm.price) : "Not available" },
                  { label: "Mortgage Balance", value: setupForm.mortgageBalance ? fmt$(setupForm.mortgageBalance) : "Not provided" },
                  { label: "Estimated Equity", value: (avmResult && avmResult.avm && avmResult.avm.price && setupForm.mortgageBalance) ? fmt$(avmResult.avm.price - Number(String(setupForm.mortgageBalance).replace(/[^0-9.]/g,""))) : "—" },
                ].map(({ label, value }) => (
                  <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid " + BORDER }}>
                    <span style={{ fontSize: "13px", color: MUTED }}>{label}</span>
                    <span style={{ fontSize: "13px", fontWeight: 700, color: NAVY }}>{value}</span>
                  </div>
                ))}
                <div style={{ background: NAVY + "08", borderRadius: "10px", padding: "12px 14px", marginTop: "16px", fontSize: "12px", color: MUTED, borderLeft: "3px solid " + GOLD }}>
                  Your value will be refreshed monthly automatically. You can manually refresh anytime from the dashboard.
                </div>
              </div>
            )}
          </div>
          {!showAnonGate && (
            <div style={{ padding: "16px 28px", borderTop: "1px solid " + BORDER, display: "flex", justifyContent: "space-between" }}>
              <Button onClick={() => setupStep > 0 ? this.setState(p => ({ setupStep: p.setupStep - 1 })) : this.setState({ showSetup: false })} style={{ borderRadius: "50px", borderColor: BORDER, color: MUTED }}>
                {setupStep === 0 ? "Cancel" : "Back"}
              </Button>
              <Button loading={avmLoading || saving} onClick={this.handleSetupNext}
                style={{ borderRadius: "50px", background: setupStep === 3 ? GOLD : NAVY, color: setupStep === 3 ? "#2A1600" : "#fff", border: "none", fontWeight: 700, minWidth: "120px" }}>
                {avmLoading ? "Pulling data..." : this.state.anonMode && setupStep === 0 ? "Confirm This Is My Home →" : setupStep === 3 ? (isEdit ? "Save Changes" : "Launch Tracker") : "Continue"}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
  renderImproveModal() {
    const { showImproveModal, improveForm, saving } = this.state;
    if (!showImproveModal) return null;
    const template = IMPROVEMENTS.find(i => i.id === improveForm.improvementId);
    return (
      <Modal visible={showImproveModal} title="Log a Home Improvement"
        onCancel={() => this.setState({ showImproveModal: false })}
        footer={[
          <Button key="cancel" onClick={() => this.setState({ showImproveModal: false })} style={{ borderRadius: "50px" }}>Cancel</Button>,
          <Button key="save" type="primary" loading={saving} onClick={this.saveImprovement} style={{ borderRadius: "50px", background: NAVY, borderColor: NAVY }}>Save Improvement</Button>
        ]}
        bodyStyle={{ padding: "20px 24px" }}>
        <Select placeholder="Select improvement type" value={improveForm.improvementId || undefined}
          onChange={v => this.setState(p => ({ improveForm: { ...p.improveForm, improvementId: v, valueImpact: "" } }))}
          style={{ width: "100%", marginBottom: "16px" }} getPopupContainer={t => t.parentNode}
          showSearch filterOption={(inp, opt) => opt.children && opt.children.toString().toLowerCase().includes(inp.toLowerCase())}>
          {IMPROVEMENT_CATEGORIES.map(cat => (
            <Select.OptGroup key={cat} label={cat}>
              {IMPROVEMENTS.filter(i => i.category === cat).map(i => <Option key={i.id} value={i.id}>{i.icon} {i.label}</Option>)}
            </Select.OptGroup>
          ))}
        </Select>
        {template && (
          <div style={{ background: GREEN + "10", border: "1px solid " + GREEN, borderRadius: "10px", padding: "12px 14px", marginBottom: "16px" }}>
            <div style={{ fontSize: "12px", fontWeight: 700, color: GREEN, marginBottom: "2px" }}>Estimated Value Impact</div>
            <div style={{ fontSize: "16px", fontWeight: 800, color: GREEN }}>{fmt$(template.valueLow)} – {fmt$(template.valueHigh)}</div>
            <div style={{ fontSize: "11px", color: MUTED }}>National average range. Actual impact depends on your market and quality of work.</div>
          </div>
        )}
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Date Completed</label>
            <Input type="date" value={improveForm.completedDate} onChange={e => this.setState(p => ({ improveForm: { ...p.improveForm, completedDate: e.target.value } }))} style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>What You Paid</label>
            <Input prefix="$" placeholder="Total cost" value={improveForm.cost} onChange={e => this.setState(p => ({ improveForm: { ...p.improveForm, cost: e.target.value } }))} style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Contractor / Company</label>
            <Input placeholder="Optional" value={improveForm.contractor} onChange={e => this.setState(p => ({ improveForm: { ...p.improveForm, contractor: e.target.value } }))} style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>
              Value Added <Tooltip title="Override the estimated value if you know a more accurate number"><InfoCircleOutlined style={{ color: MUTED }} /></Tooltip>
            </label>
            <Input prefix="$" placeholder={template ? ("Est. " + fmt$(Math.round((template.valueLow + template.valueHigh) / 2))) : ""}
              value={improveForm.valueImpact} onChange={e => this.setState(p => ({ improveForm: { ...p.improveForm, valueImpact: e.target.value } }))} style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={24}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Notes</label>
            <Input.TextArea rows={2} placeholder="e.g. Replaced 25yr old roof with architectural shingles, 50yr warranty"
              value={improveForm.notes} onChange={e => this.setState(p => ({ improveForm: { ...p.improveForm, notes: e.target.value } }))} style={{ borderRadius: "10px" }} />
          </Col>
        </Row>
      </Modal>
    );
  }
  // ── Property switcher tabs ─────────────────────────────────────────────────────
  isAgentOrLender = () => {
    const { userDetails } = this.props.context.state;
    const profile = userDetails && userDetails.userProfile;
    return profile === "AG" || profile === "L";
  };
  deleteProperty = async (tracker) => {
    const { userDetails } = this.props.context.state;
    if (!window.confirm(`Delete "${(tracker.address || "this property").split(",")[0]}"? This will also remove its value history and improvements. This cannot be undone.`)) return;
    this.setState({ loading: true });
    try {
      // Delete the tracker record itself
      await mhbUpdate("mybuddha", tracker.id, { deleted: true, deletedAt: new Date().toISOString(), updatedAt: new Date().toISOString() });
      notification.success({ message: "Property removed." });
      await this.loadTrackers();
    } catch(e) {
      notification.error({ message: "Delete failed", description: String(e.message || e) });
      this.setState({ loading: false });
    }
  };
  renderPropertySwitcher() {
    const { trackers, activeTrackerId } = this.state;
    if (!trackers || trackers.length === 0) return null;
    const canDelete = this.isAgentOrLender() || trackers.length > 1;
    return (
      <div style={{ padding: "16px 16px 0", display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
        {trackers.map(t => {
          const unreadCount = this.getUnreadCountForTracker(t.id);
          return (
          <div key={t.id} style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
            <button onClick={() => this.switchProperty(t.id)}
              style={{
                padding: "8px 16px",
                paddingRight: canDelete ? "32px" : "16px",
                borderRadius: "50px",
                border: "1.5px solid " + (t.id === activeTrackerId ? NAVY : BORDER),
                background: t.id === activeTrackerId ? NAVY : WHITE,
                color: t.id === activeTrackerId ? WHITE : NAVY,
                fontSize: "12px", fontWeight: 700, cursor: "pointer",
                maxWidth: "220px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
              }}>
              🏠 {(t.address || "Property").split(",")[0]}
            </button>
            {unreadCount > 0 && (
              <span title={unreadCount + " update" + (unreadCount !== 1 ? "s" : "") + " available"}
                style={{
                  position: "absolute", top: "-4px", left: canDelete ? "10px" : "10px",
                  background: GOLD, color: "#2A1600", borderRadius: "50%",
                  minWidth: "16px", height: "16px", fontSize: "10px", fontWeight: 800,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  border: "1.5px solid " + WHITE, padding: "0 2px", lineHeight: 1,
                }}>
                {unreadCount}
              </span>
            )}
            {canDelete && (
              <button onClick={e => { e.stopPropagation(); this.deleteProperty(t); }}
                title="Remove this property"
                style={{
                  position: "absolute", right: "6px",
                  background: "none", border: "none", cursor: "pointer",
                  color: t.id === activeTrackerId ? "rgba(255,255,255,0.6)" : "#CBD5E0",
                  fontSize: "12px", lineHeight: 1, padding: "2px",
                }}>✕</button>
            )}
          </div>
          );
        })}
        <button onClick={this.openAddProperty}
          style={{ padding: "8px 16px", borderRadius: "50px", border: "1.5px dashed " + BORDER, background: WHITE, color: MUTED, fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>
          + Add Property
        </button>
        {this.isAgentOrLender() && (
          <button onClick={() => this.setState({ showClientSetup: true })}
            style={{ padding: "8px 16px", borderRadius: "50px", border: "1.5px solid " + GOLD, background: "#FFFBF0", color: "#92400E", fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>
            👥 Set Up a Client
          </button>
        )}
      </div>
    );
  }
  // ── Quick Edit modal — update mortgage balance / rate / price / tax only ──────
  renderQuickEditModal() {
    const { showQuickEdit, quickEditForm, saving } = this.state;
    if (!showQuickEdit) return null;
    return (
      <Modal visible={showQuickEdit} title="Quick Update"
        onCancel={() => this.setState({ showQuickEdit: false })}
        footer={[
          <Button key="cancel" onClick={() => this.setState({ showQuickEdit: false })} style={{ borderRadius: "50px" }}>Cancel</Button>,
          <Button key="save" type="primary" loading={saving} onClick={this.saveQuickEdit} style={{ borderRadius: "50px", background: NAVY, borderColor: NAVY }}>Save</Button>
        ]}
        bodyStyle={{ padding: "20px 24px" }}>
        <div style={{ fontSize: "12px", color: MUTED, marginBottom: "16px" }}>
          Update your mortgage balance after a payment, or correct your purchase price — no need to re-run a full setup.
        </div>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Mortgage Balance</label>
            <Input prefix="$" placeholder="e.g. 355000" value={quickEditForm.mortgageBalance}
              onChange={e => this.setState(p => ({ quickEditForm: { ...p.quickEditForm, mortgageBalance: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Interest Rate</label>
            <Input suffix="%" placeholder="e.g. 6.75" value={quickEditForm.mortgageRate}
              onChange={e => this.setState(p => ({ quickEditForm: { ...p.quickEditForm, mortgageRate: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Purchase Price</label>
            <Input prefix="$" placeholder="e.g. 450000" value={quickEditForm.purchasePrice}
              onChange={e => this.setState(p => ({ quickEditForm: { ...p.quickEditForm, purchasePrice: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Annual Property Tax</label>
            <Input prefix="$" placeholder="e.g. 6200" value={quickEditForm.propertyTax}
              onChange={e => this.setState(p => ({ quickEditForm: { ...p.quickEditForm, propertyTax: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Loan Type</label>
            <Select value={quickEditForm.mortgageType} onChange={v => this.setState(p => ({ quickEditForm: { ...p.quickEditForm, mortgageType: v } }))} style={{ width: "100%" }} getPopupContainer={t => t.parentNode}>
              {["30yr fixed","20yr fixed","15yr fixed","10yr fixed","5/1 ARM","7/1 ARM","No mortgage / Paid off"].map(t => <Option key={t} value={t}>{t}</Option>)}
            </Select>
          </Col>
        </Row>
        <div style={{ background: NAVY + "08", borderRadius: "10px", padding: "10px 14px", marginTop: "16px", fontSize: "11px", color: MUTED, borderLeft: "3px solid " + GOLD }}>
          Your equity will recalculate automatically based on your current market value.
        </div>
      </Modal>
    );
  }
  // ── Client Setup modal — agent/lender prepares a Value Tracker invite ─────────
  // ── Send client invite — creates home_profile record with prefill + sends templated email ──
  // FIX: routed through portal's own Lambda (mhbAdd "sendInviteEmail") instead of
  // a direct fetch() to the Netlify mhb-invite function, which is blocked by CORS
  // because the portal (myhomebuddha.com) and the AI site (ai.myhomebuddha.com) are
  // separate origins with no Access-Control-Allow-Origin header configured for that route.
  sendClientInvite = async () => {
    const { clientSetupForm } = this.state;
    const { userDetails } = this.props.context.state;
    if (!clientSetupForm.clientEmail || !clientSetupForm.clientEmail.includes("@")) {
      notification.warning({ message: "Please enter a valid client email" });
      return;
    }
    if (!clientSetupForm.address) {
      notification.warning({ message: "Please enter the property address" });
      return;
    }
    this.setState({ sendingInvite: true });
    try {
      const valueTrackerPrefill = {
        purchasePrice:   clientSetupForm.purchasePrice,
        purchaseDate:    clientSetupForm.purchaseDate,
        mortgageBalance: clientSetupForm.mortgageBalance,
        mortgageRate:    clientSetupForm.mortgageRate,
        mortgageType:    clientSetupForm.mortgageType || "30yr fixed",
        downPayment:     clientSetupForm.downPayment,
        propertyTax:     clientSetupForm.propertyTax,
      };
      // Resolve client's userId if they already have an account
      let targetUserId = userDetails.id;
      try {
        const cl = await noAuthGetInfo("checkUser/" + encodeURIComponent(clientSetupForm.clientEmail));
        if (cl && cl.success && cl.data && cl.data[0] && cl.data[0].id) targetUserId = cl.data[0].id;
      } catch(e) { /* not found — will live under agent's account until signup */ }
      const homeRecord = await mhbAdd("mybuddha", {
        userId: targetUserId,
        agentId: userDetails.id,
        type: "home_profile", action: "home_profile",
        address: clientSetupForm.address,
        nickname: clientSetupForm.address.split(",")[0] || (clientSetupForm.clientName + "'s Home"),
        homeDetails: {},
        coUsers: [{ email: clientSetupForm.clientEmail, name: clientSetupForm.clientName || clientSetupForm.clientEmail.split("@")[0], role: "owner", addedAt: Date.now() }],
        valueTrackerPrefill,
        setupSource: "value_tracker_invite",
        createdBy: userDetails.id, createdAt: Date.now(),
      });
      // ── FIX: send templated invite email via the portal's own Lambda route ──
      // (same "sendInviteEmail" route HomeBuddha.js uses) instead of fetching the
      // Netlify mhb-invite function directly, which CORS-blocks cross-origin calls
      // from [www.myhomebuddha.com](https://www.myhomebuddha.com).
      const agentName = ((userDetails.firstName || "") + " " + (userDetails.lastName || "")).trim();
      const agBrand = JSON.parse(localStorage.getItem("mhb_agent_brand") || "{}");
      await mhbAdd("sendInviteEmail", {
        toEmail:      clientSetupForm.clientEmail,
        toName:       clientSetupForm.clientName || clientSetupForm.clientEmail.split("@")[0],
        fromName:     agentName,
        fromEmail:    userDetails.email || "",
        agentId:      userDetails.id || "",
        agentPhone:   userDetails.phone || userDetails.phno || "",
        agentPhoto:   agBrand.photo || "",
        agentCompany: agBrand.company || agBrand.brokerage || (userDetails.newdata && userDetails.newdata.companyName) || "",
        address:      clientSetupForm.address,
        homeId:       (homeRecord && homeRecord.data && homeRecord.data.id) || (homeRecord && homeRecord.id) || "",
        templateId:   "d-c5bad335ea5f46f8865b9de868d19045",
        reports:      [],
      });
      notification.success({ message: "Invite sent to " + clientSetupForm.clientEmail + "!", description: "Their Value Tracker will be pre-filled with the details you entered." });
      this.setState({
        showClientSetup: false, sendingInvite: false,
        clientSetupForm: {
          clientName: "", clientEmail: "",
          address: "", purchasePrice: "", purchaseDate: "",
          mortgageBalance: "", mortgageRate: "", mortgageType: "30yr fixed",
          downPayment: "", propertyTax: "",
        },
      });
    } catch(e) {
      notification.error({ message: "Failed to send invite", description: String(e.message || e) });
      this.setState({ sendingInvite: false });
    }
  };
  renderClientSetupModal() {
    const { showClientSetup, clientSetupForm, sendingInvite } = this.state;
    if (!showClientSetup) return null;
    return (
      <Modal visible={showClientSetup} title="Set Up a Client's Value Tracker"
        onCancel={() => this.setState({ showClientSetup: false })}
        footer={[
          <Button key="close" onClick={() => this.setState({ showClientSetup: false })} style={{ borderRadius: "50px" }}>Cancel</Button>,
          <Button key="send" type="primary" loading={sendingInvite} onClick={this.sendClientInvite}
            style={{ borderRadius: "50px", background: GOLD, borderColor: GOLD, color: "#2A1600", fontWeight: 700 }}>
            📨 Send Invite
          </Button>
        ]}
        bodyStyle={{ padding: "20px 24px" }}>
        <div style={{ fontSize: "12px", color: MUTED, marginBottom: "16px" }}>
          Enter what you know about your client's purchase — price, mortgage, rate. We'll email them a branded invite to My Home Buddha, and their Value Tracker will be pre-filled with these details — they just confirm and launch.
        </div>
        <Row gutter={[12, 12]}>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Client Name</label>
            <Input placeholder="e.g. John Smith" value={clientSetupForm.clientName}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, clientName: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Client Email</label>
            <Input placeholder="john@example.com" value={clientSetupForm.clientEmail}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, clientEmail: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={24}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Property Address</label>
            <Input placeholder="123 Main St, Westborough, MA 01581" value={clientSetupForm.address}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, address: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Purchase Price</label>
            <Input prefix="$" placeholder="e.g. 450000" value={clientSetupForm.purchasePrice}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, purchasePrice: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Closing / Purchase Date</label>
            <Input type="date" value={clientSetupForm.purchaseDate}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, purchaseDate: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Mortgage Balance</label>
            <Input prefix="$" placeholder="e.g. 405000" value={clientSetupForm.mortgageBalance}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, mortgageBalance: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Interest Rate</label>
            <Input suffix="%" placeholder="e.g. 6.75" value={clientSetupForm.mortgageRate}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, mortgageRate: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Loan Type</label>
            <Select value={clientSetupForm.mortgageType} onChange={v => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, mortgageType: v } }))} style={{ width: "100%" }} getPopupContainer={t => t.parentNode}>
              {["30yr fixed","20yr fixed","15yr fixed","10yr fixed","5/1 ARM","7/1 ARM"].map(t => <Option key={t} value={t}>{t}</Option>)}
            </Select>
          </Col>
          <Col span={12}>
            <label style={{ fontSize: "11px", fontWeight: 700, color: NAVY, textTransform: "uppercase", display: "block", marginBottom: "6px" }}>Down Payment</label>
            <Input prefix="$" placeholder="e.g. 45000" value={clientSetupForm.downPayment}
              onChange={e => this.setState(p => ({ clientSetupForm: { ...p.clientSetupForm, downPayment: e.target.value } }))}
              style={{ borderRadius: "10px" }} />
          </Col>
        </Row>
        <div style={{ background: NAVY + "08", borderRadius: "10px", padding: "10px 14px", marginTop: "16px", fontSize: "11px", color: MUTED, borderLeft: "3px solid " + GOLD }}>
          Your client will receive an email invite to My Home Buddha. Once they log in, their Value Tracker setup will be pre-filled with everything you entered above — they just confirm and launch.
        </div>
      </Modal>
    );
  }
  render() {
    const { loading, activeTab, showSetup } = this.state;
    const trackerRecord = this.getActiveTracker();
    const hasAnyTracker = this.state.trackers && this.state.trackers.length > 0;
    if (loading) {
      return (
        <div style={{ textAlign: "center", padding: "60px", color: MUTED }}>
          <Spin size="large" />
          <div style={{ marginTop: "12px" }}>Loading your Value Tracker...</div>
        </div>
      );
    }
    return (
      <div style={{ background: BG, minHeight: "400px" }}>
        <div style={{ padding: "16px 16px 0" }}>
          {this.renderImportPanel()}
        </div>
        {this.renderPropertySwitcher()}
        {!hasAnyTracker && !showSetup && (
          <div style={{ padding: "24px", textAlign: "center" }}>
            <div style={{ fontSize: "32px", marginBottom: "12px" }}>🏡</div>
            <div style={{ fontSize: "18px", fontWeight: 800, color: NAVY, marginBottom: "6px" }}>Get Your Home Value & Set Up Your Value Tracker</div>
            <div style={{ fontSize: "14px", color: MUTED, marginBottom: "20px", maxWidth: "400px", margin: "0 auto 20px" }}>
              Track your home value, equity, and appreciation over time.
            </div>
            <Button type="primary" size="large" onClick={this.openAddProperty}
              style={{ borderRadius: "50px", background: NAVY, borderColor: NAVY, fontWeight: 700, height: "48px", padding: "0 32px" }}>
              Get Your Home Value Now!
            </Button>
            <div style={{ marginTop: "16px" }}>
              {this.isAgentOrLender() && (
                <button onClick={() => this.setState({ showClientSetup: true })}
                  style={{ padding: "8px 20px", borderRadius: "50px", border: "1.5px solid " + GOLD, background: "#FFFBF0", color: "#92400E", fontSize: "12px", fontWeight: 700, cursor: "pointer" }}>
                  👥 Set Up a Client Instead
                </button>
              )}
            </div>
          </div>
        )}
        {trackerRecord && (
          <Tabs activeKey={activeTab} onChange={key => this.setState({ activeTab: key })}
            tabBarStyle={{ padding: "0 16px", background: WHITE, marginBottom: 0 }}
            tabBarExtraContent={
              <Button size="small" icon={<PlusOutlined />} onClick={() => this.setState({ showImproveModal: true })}
                style={{ borderRadius: "50px", background: GOLD, borderColor: GOLD, color: "#2A1600", fontWeight: 700, marginRight: "8px" }}>
                Log Improvement
              </Button>
            }>
            <TabPane tab="Dashboard" key="dashboard">{this.renderDashboard()}</TabPane>
            <TabPane tab={"Improvements (" + this.state.improvements.length + ")"} key="improvements">{this.renderImprovements()}</TabPane>
            <TabPane tab="Comps" key="comps">{this.renderComps()}</TabPane>
          </Tabs>
        )}
        {this.renderSetupModal()}
        {this.renderImproveModal()}
        {this.renderQuickEditModal()}
        {this.renderClientSetupModal()}
      </div>
    );
  }
}
export default withAppContext(withRouter(ValueTracker));